import { cn, renderBankLogo } from "../../utils/utils";
import PropTypes from "prop-types";

import { useGetDestinationIbans } from "../../lib/queries/queriesAndMutations";

const MemorizedIbansList = ({ className, setValue, clearErrors,setIsDropdownOpen }) => {
  const debouncedQueryParams = {};
  const currentPage = 1;

  const { data: destinations } = useGetDestinationIbans({
    debouncedQueryParams,
    currentPage,
  });

  const handleSelection = (item, close) => {
    setValue("iban", item?.iban.slice(2));
    setValue("iban_nickname", item?.iban_nickname??"");
    clearErrors("iban");
    setIsDropdownOpen(false)
  };

  return (
    <div className="   bg-white  max-h-[200px] rounded-md  overflow-y-scroll vanda-wallet-scrllbar ">
      {!destinations?.count ? (
        <div className="flex flex-col min-h-[300px]  m-auto justify-center items-center gap-6">
          <div className="bg-neutral-10 flex flex-col items-center p-6 rounded-md">
            <img
              src="/images/bankcard.svg"
              alt=""
              className="max-w-[40px] max-h-[40px]"
            />
            <p> شماره شبای ذخیره شده ای برای شما ثبت نشده است!</p>
          </div>
        </div>
      ) : (
        <>
          <div
            className={cn(
              "col-span-1 xl:col-span-1 flex flex-col gap-1 pl-[6px] bg-white min-w-[320px] ",
              className
            )}
          >
            {destinations?.results.map((item) => (
              <>
                <div
                  key={item.destination_iban}
                  className="flex gap-2  p-2 rounded-md items-center cursor-pointer "
                  onClick={() => handleSelection(item)}
                >
                  {renderBankLogo(item)}
                  <div className="flex flex-col">
                    <p className="text-[12px] text-neutral-40 font-semibold">
                      {item.iban_nickname}
                    </p>
                    <p className="text-[12px] text-dark font-semibold">
                      {item.iban}
                    </p>
                  </div>
                </div>
                <div class="p-[1px] rounded-[6px] bg-gradient-to-r from-white h-[1px] w-full from-0 via-[#ccc] via-50 to-white to-100"></div>
              </>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

MemorizedIbansList.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      destination_bank: PropTypes.string.isRequired,
      destination_name: PropTypes.string.isRequired,
      destination_iban: PropTypes.string.isRequired,
    })
  ).isRequired,
  className: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  onClose: PropTypes.func, // Optional callback for closing the popup
};

export default MemorizedIbansList;
